import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

type Props = {
  show?: boolean;
  header?: boolean;
  HeaderContent?: any;
  BodyContent: any;
  footer?: boolean;
  FooterContent?: any;
  modalWidth?: string;
  closeButton?: boolean;
  customClass?: string;
  CloseContent?: any;
  ParentClass?: any;
  handleClose?: any;
}

export default function CustomModal({
  show,
  header,
  HeaderContent,
  BodyContent,
  footer,
  FooterContent,
  modalWidth,
  closeButton,
  CloseContent,
  customClass,
  ParentClass,
  handleClose,
  ...args
}: Props) {
  const [showModal, setShowModal] = useState(show ? show : false);
  return showModal ? (
    <div className={`custom-modal-wrap`}>
      <Modal
        show={showModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`custom-modal ${ParentClass?ParentClass:""}`}>
        {header && (
          <Modal.Header onHide={handleClose} closeButton={closeButton ? true : false}><HeaderContent></HeaderContent></Modal.Header>
        )}
        <Modal.Body className={`${customClass ? customClass : ""}`}>
          {closeButton && (
            <button
              className="btn modal-close-btn btn-close"
              onClick={() => {
                CloseContent ? CloseContent() : setShowModal(false);
              }}
            ></button>
          )}
          <BodyContent />
        </Modal.Body>
        {footer && (
          <Modal.Footer>
            <FooterContent />
          </Modal.Footer>
        )}
      </Modal>
    </div>
  ) : show !== true ? (
    <button
      className="btn btn-success w-10"
      data-testid="buttoncomponent"
      style={{ width: "200px" }}
      onClick={() => setShowModal(true)}
    >
      Open Modal
    </button>
  ) : (
    <></>
  );
}
